<ng-container *ngTemplateOutlet="panel; context: {side:'left'}"></ng-container>
@if (closed && showBar) {
  <div class="toggle-bar" (click)="toggle()" [ngClass]="{'right-side': closed === 'left'}">
    @if (closed === 'right') {
      <i class="fal fa-angle-double-left"></i>
    }
    Visa
    @if (closed === 'left') {
      <i class="fal fa-angle-double-right"></i>
    }
  </div>
}
<ng-container *ngTemplateOutlet="panel; context: {side:'right'}"></ng-container>

<ng-template #panel let-side="side">

  <div class="vertical-content {{side}}-panel {{side === 'left' ? leftClassSum : rightClassSum}}">
    <ng-container *ngTemplateOutlet="side === 'right' ? rightContent : leftContent"></ng-container>

    @if (showFlap && flapVisible(side)) {
      <rask-flap-button
        [ngClass]="{'inverted': side === 'left'}"
        [ngStyle]="{'top': flapPosTop}"
        (click)="toggle(side)"
        [buttonState]="closed === side">
        {{getText(side)}}
      </rask-flap-button>
    }
  </div>
</ng-template>

<ng-template #leftContent>
  <ng-content select="[left]"></ng-content>
</ng-template>

<ng-template #rightContent>
  <ng-content select="[right]"></ng-content>
</ng-template>
